<!-- eslint-disable vue/html-self-closing -->
<template>
  <div
    class="gf-file-uploader"
    :class="{ '--disabled': isDisabled }"
    :style="{
      '--gf-file-uploader-width': uploaderWidth,
      '--gf-file-uploader-background': uploaderBackground
    }"
  >
    <label
      class="gf-file-uploader__uploader"
      :for="uploaderId"
    >
      <div
        class="gf-file-uploader__uploader__custom-button"
        :class="{ 'border-danger': hasError }"
      >
        <span>
          Выберите файл
          <span v-if="arrayOfAllowedExtensions?.length === 1">
            c расширением {{ formattedAllowedExtensions }}
          </span>
          <span v-else>с расширениями {{ formattedAllowedExtensions }}</span>
        </span>
      </div>
      <input
        :id="uploaderId"
        ref="inputUploader"
        :name="uploaderName"
        type="file"
        :disabled="isDisabled"
        :accept="allowedExtentions"
        @change="onUploaderInputChange"
        @drop="onDrop"
        @dragenter="onDragEnter"
        @dragleave="onDragLeave"
      />
      <button
        v-if="file"
        class="d-flex align-items-center gf-file-uploader__delete-btn btn"
        @click="onResetButtonClick"
      >
        <i class="gf-icon gf-icon-x" />
      </button>
      <div
        class="gf-file-uploader__progress"
        :class="{ '--uploading': isUploading }"
      >
        <svg
          class="progress-circle"
          width="40"
          height="40"
        >
          <circle
            class="progress-circle__background"
            r="16"
            cx="20"
            cy="20"
            fill="transparent"
            stroke="var(--text)"
            stroke-width="3"
          />
          <circle
            ref="progressCircle"
            class="progress-circle__progress"
            r="16"
            cx="20"
            cy="20"
            fill="transparent"
            stroke="var(--primary)"
            stroke-width="4"
            stroke-dasharray="200"
            stroke-dashoffset="200"
            transform="rotate(-90 20 20)"
          />
          <text
            ref="progressCircleText"
            x="20"
            y="20"
            text-anchor="middle"
            fill="var(--text)"
            font-size="10"
          >
            0%
          </text>
        </svg>
      </div>
    </label>
    <span
      class="gf-file-uploader__file-name text-nowrap"
      v-if="!isDisabled"
    >
      <span v-if="!file && !fileName">Файл не выбран</span>
      <span
        class="text-truncate"
        v-else
      >
        {{ fileName }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'GfCustomFileUploader',
  props: {
    uploaderId: {
      type: String,
      default: 'customUploader'
    },
    allowedExtentions: {
      type: String,
      default: ''
    },
    uploaderName: {
      type: String,
      default: 'uploaderName'
    },
    uploaderWidth: {
      type: String,
      default: '350px'
    },
    uploaderBackground: {
      type: String,
      default: 'var(--light)'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    value: {}
  },
  data() {
    return {
      file: null,
      fileName: null,
      inputUploader: null,
      progressCircle: null,
      progressCircleText: null,
      isUploading: false,
      arrayOfAllowedExtensions: null,
      formattedAllowedExtensions: null,
      isDisabled: false
    };
  },
  watch: {
    disabled() {
      this.isDisabled = this.disabled;
      if (this.isDisabled) this.resetFiles();
    }
  },
  mounted() {
    this.inputUploader = this.$refs.inputUploader;
    this.progressCircle = this.$refs.progressCircle;
    this.progressCircleText = this.$refs.progressCircleText;
    if (this.value) {
      this.$refs.inputUploader.files[0] = this.value;
      this.file = this.value;
    }
    this.makeArrayOfAllowedExtensions();
    this.isDisabled = this.disabled;
  },
  methods: {
    onUploaderInputChange() {
      // this.isUploading = true;
      // this.updateProgress(0);
      // this.file = null;
      // this.emitData();
      this.file = this.inputUploader.files[0];
      this.fileName = this.file.name;
      this.emitData();
      // if (this.file) {
      //   const reader = new FileReader();

      //   reader.onprogress = (event) => {
      //     if (event.lengthComputable) {
      //       const progress = (event.loaded / event.total) * 100;
      //       this.updateProgress(progress);
      //       if (progress === 100) {
      //         this.emitData();
      //         setTimeout(() => {
      //           this.isUploading = false;
      //         }, 400);
      //       }
      //     }
      //   };
      //   reader.readAsDataURL(this.file);
      // }

      // Эмитирование события в DOM для не вуйных страниц / элементов
      this.dispatchUploadedEventForNonVuePages();
    },
    dispatchUploadedEventForNonVuePages() {
      const event = new CustomEvent('GfCustomFileUploaderUploadedEvent', {
        detail: { message: 'UPLOADED' }
      });
      document.dispatchEvent(event);
    },
    dispatchResetEventForNonVuePages() {
      const event = new CustomEvent('GfCustomFileUploaderResetEvent', {
        detail: { message: 'RESET' }
      });
      document.dispatchEvent(event);
    },
    updateProgress(progress) {
      const circumference = 200;
      const offset = circumference - (progress / 100) * circumference;
      this.progressCircle.style.strokeDashoffset = offset;
      this.progressCircleText.textContent = `${progress.toFixed(0)}%`;
    },
    resetFiles() {
      // this.updateProgress(0);
      this.inputUploader.value = '';
      this.file = null;
      this.fileName = null;
      this.emitData();
      this.dispatchResetEventForNonVuePages();
    },
    emitData() {
      this.$emit('input', this.file);
    },
    onDragEnter() {
      this.inputUploader.classList.add('--dragenter');
    },
    onDragLeave() {
      this.inputUploader.classList.remove('--dragenter');
    },
    onDrop() {
      this.onDragLeave();
      this.dispatchUploadedEventForNonVuePages();
    },
    onResetButtonClick(e) {
      e.preventDefault();
      this.resetFiles();
    },
    makeArrayOfAllowedExtensions() {
      this.arrayOfAllowedExtensions = this.allowedExtentions.split(', ');
      this.formattedAllowedExtensions = this.arrayOfAllowedExtensions.join('/');
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-file-uploader';

#{$this} {
  width: var(--gf-file-uploader-width);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  --gf-file-uploader-width: 350px;

  @media (min-width: 576px) {
    flex-direction: row;
    align-items: center;
  }

  #{$this}__uploader {
    position: relative;
    cursor: pointer;
    margin-bottom: 3px;
    margin-right: 8px;
    white-space: nowrap;

    &__file-name {
      color: var(--gray);
    }

    &__custom-button {
      width: var(--gf-file-uploader-width);
      max-width: 100%;
      padding: 7px 30px 7px 10px;
      background-color: var(--gf-file-uploader-background);
      border-radius: var(--border-radius);
      border: 1px solid var(--border-color);
      transition: box-shadow 0.2s ease-in-out;
    }
  }
  #{$this}__uploader > input[type='file'] {
    display: none;

    &.--dragenter {
      -webkit-box-shadow: 0px 0px 8px 0px var(--primary);
      -moz-box-shadow: 0px 0px 8px 0px var(--primary);
      box-shadow: 0px 0px 8px 0px var(--primary);
    }

    &::file-selector-button {
      padding: 0.375rem 0.75rem;
      margin-right: 10px;
      color: var(--text);
      background-color: var(--light);
      border: 1px solid var(--border-color);
      border-radius: var(--border-radius);
      cursor: pointer;
      transition: background 0.2s ease-in-out;

      &:hover {
        background-color: var(--bg-light);
      }
    }
  }

  #{$this}__delete-btn {
    position: absolute;
    top: 1px;
    right: -5px;
    color: var(--text-muted);

    &:hover {
      color: var(--text);
    }

    &:focus {
      box-shadow: none;
    }
  }
  #{$this}__progress {
    opacity: 0;
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: var(--bg-transparent);
    backdrop-filter: blur(1px);
    z-index: -1;
    transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1),
      background-color 0.15s cubic-bezier(0, 0, 0.2, 1);

    &.--uploading {
      opacity: 1;
      z-index: 0;
      transition: opacity 0.2s cubic-bezier(0, 0, 0.2, 1),
        background-color 0.15s cubic-bezier(0, 0, 0.2, 1);
    }

    .progress-circle {
      position: absolute;
      display: block;
      top: calc(50% - 20px);
      left: calc(50% - 20px);
    }

    .progress-circle__background {
      transition: stroke-dashoffset 0.3s;
    }

    .progress-circle__progress {
      transition: stroke-dashoffset 0.3s;
    }

    .progress-circle text {
      dominant-baseline: central;
      text-anchor: middle;
      font-family: Arial, sans-serif;
    }
  }
}

#{$this}.--disabled {
  color: var(--text-muted);
}
</style>
